import ApiService from './ApiService';

// API ключи
const API_KEY = 'e76250aff25c3bdaf7619c52d4cdfc1c'; // Можно заменить на ваш ключ
const HOST = 'v3.football.api-sports.io';

// Create and export a singleton instance
const apiService = new ApiService(API_KEY, HOST);

export default apiService; 